import React from 'react';
import {Link, withRouter } from 'react-router-dom';
import EmptyTrackerImg from '../../images/empty-tracker.png'

@withRouter
export default class EmptyTracker extends React.Component{
    render(){
        return(
            <section className="no-results section-center">
                <div className="section-center-wrapper">
                    <h3 className="title">Your education activity will be displayed here</h3>
                    <img src={EmptyTrackerImg} alt="Empty Tracker"/>
                    {/* <p className="desc">Browse all categories to watch your first tutorial</p> */}
                    {/* <div className="button-set">
                        <Link
                            to='/categories'
                            className="btn blue rounded">
                            All Categories
                        </Link>
                    </div> */}
                </div>
            </section>
        )
    }
}







// WEBPACK FOOTER //
// ./src/modules/blocks/EmpryTracker.js